// ── USERS → "CHECK-INS" TAB ──────────────────────────────────────────────────
// One section per course day, laid out like the Journal tab. A check-in is the
// three 0–5 ratings the client gives on that day's journal page
// (DayJournal.jsx → POST /api/checkin → ry_checkins, one row per day). The
// question wording and the three result bands come from the SAME constants the
// client saw (utils/constants.js CHECKIN_QUESTIONS_BY_DAY /
// CHECKIN_BANDS_BY_DAY), mapped positionally to calm_score / connected_score /
// clarity_score (those column names are historical).
//
// The time shown is when the check-in was FIRST submitted: re-submitting the
// same day updates the scores but keeps that first time (created_at).

import { C } from './adminShared';
import { DAYS, CHECKIN_QUESTIONS_BY_DAY, CHECKIN_BANDS_BY_DAY } from '../../utils/constants';

const fmtWhen = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};
const bandOf = (day, total) => {
  const bands = CHECKIN_BANDS_BY_DAY[day];
  if (!bands || total == null) return null;
  return total <= 5 ? bands[0] : total <= 10 ? bands[1] : bands[2];
};

export const ClientCheckinsTab = ({ checkins }) => {
  const byDay = {};
  (checkins || []).forEach((c) => { byDay[c.day_num] = c; });
  const days = DAYS.map((d) => ({ num: d.num, title: d.title }));
  // A Call Day (7) check-in is not asked for, but show one if it was ever stored.
  if (byDay[7]) days.push({ num: 7, title: 'Call Day' });

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {days.map((day, di) => {
        const c = byDay[day.num];
        const scores = c ? [c.calm_score, c.connected_score, c.clarity_score] : [];
        const questions = CHECKIN_QUESTIONS_BY_DAY[day.num] || [];
        const band = c ? bandOf(day.num, c.total_score) : null;
        return (
          <div key={day.num} style={{ paddingBottom: 20, marginBottom: 20, borderBottom: di < days.length - 1 ? `1px solid ${C.border}` : 'none' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: C.heading }}>Day {day.num} — {day.title}</div>
              {c && <div style={{ fontSize: 11, color: C.accent }}>Submitted {fmtWhen(c.created_at)}</div>}
            </div>
            {c ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {[0, 1, 2].map((i) => (
                  <div key={i} style={{ paddingLeft: 12, borderLeft: `3px solid ${C.border}`, display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                    <div style={{ flex: 1, minWidth: 0, fontSize: 11.5, color: C.text, lineHeight: 1.55 }}>
                      {questions[i]?.label || `Question ${i + 1}`}
                    </div>
                    <div style={{ flexShrink: 0, fontSize: 13, fontWeight: 700, color: C.heading, whiteSpace: 'nowrap' }}>
                      {scores[i] ?? '—'}<span style={{ fontSize: 10, fontWeight: 600, color: C.accent }}> / 5</span>
                    </div>
                  </div>
                ))}
                <div style={{ fontSize: 12, color: C.heading, marginTop: 2 }}>
                  <strong>Total {c.total_score ?? '—'} / 15</strong>
                  {band && <span style={{ color: C.accent }}> — they were shown: “{band.label}”</span>}
                </div>
              </div>
            ) : (
              <div style={{ fontSize: 12, color: C.accent, fontStyle: 'italic' }}>No check-in submitted</div>
            )}
          </div>
        );
      })}
    </div>
  );
};
